export function removedHashLink(url: string): string {
    return `${url.substring(0, url.lastIndexOf('#') + 1)}`;
}